import React from "react";
import { Navigate } from "react-router-dom";

// About content is integrated into the root landing page (Login.jsx).
const About = () => <Navigate to="/" replace />;

export default About;
